import React, { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import SignatureCanvas from "react-signature-canvas"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

import { signMyContract } from "store/actions/contractsAction"
import { showAlert } from "store/reducers/alertReducer"

const SignatureModal = ({ isOpen, toggleModal, trigger }) => {
  const { t } = useTranslation()
  const [signatureStarted, setSignatureStarted] = useState(true)

  const sigCanvas = useRef()
  const dispatch = useDispatch()

  const clearSignature = () => {
    setSignatureStarted(false)
    sigCanvas.current.clear()
  }

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",")
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }

    return new File([u8arr], filename, { type: mime })
  }

  const saveSignature = () => {
    const signatureData = sigCanvas.current.toDataURL("image/png")
    const file = dataURLtoFile(signatureData, "signature.png")

    const formData = new FormData()
    formData.append("sign", file)
    formData.append("status", 1)

    dispatch(signMyContract(formData))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          toggleModal()
          trigger()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(err => {})
  }

  return (
    <Modal isOpen={isOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>{t("Signature")}</ModalHeader>
      <ModalBody>
        <SignatureCanvas
          ref={sigCanvas}
          penColor="black"
          onBegin={() => setSignatureStarted(true)}
          canvasProps={{
            width: 500,
            height: 200,
            className: "border rounded w-100",
          }}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleModal}>
          {t("Close")}
        </Button>
        <Button color="secondary" onClick={clearSignature}>
          {t("Clear")}
        </Button>
        <Button
          color="primary"
          disabled={!signatureStarted}
          onClick={saveSignature}
        >
          {t("Save")}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default SignatureModal
